import * as React from "react";
import FeatureFlag from "../feature-flags/feature-flag/FeatureFlag";
import RaffleAiContainer from "./RaffleAiContainer";

interface ProductPageRaffleWidgetProps {
  productCode: string;
}

/**
 * Temporary wrapper component for Angular integration that includes the feature flag check.
 *
 * This component only exists to wrap RaffleAiContainer with the EnableRaffleAi feature flag.
 * Once the feature flag can be removed (when Raffle is fully rolled out), this component
 * can be deleted and RaffleAiContainer can be exposed directly to Angular.
 */
const ProductPageRaffleWidget: React.FC<ProductPageRaffleWidgetProps> = ({
  productCode
}) => {
  return (
    <FeatureFlag name="EnableRaffleAi">
      <RaffleAiContainer productCode={productCode} />
    </FeatureFlag>
  );
};

export default ProductPageRaffleWidget;
